
import {createComponentSimulation} from '@wixc3/simulation-core';
import {StylableButton} from '../../StylableButton';

export default createComponentSimulation({
  componentType: StylableButton,
  name: 'StylableButtonPreset27',
  readOnly: true,
  props: {
    label: 'Stylable_Button_Settings_ButtonText_Default_Home_Icon',
    svgId: '11062b_d1377387c31e4fbfa19dfffdd086144d.svg',
  },
});
